"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(props) {
  return /*#__PURE__*/_react.default.createElement(_Menu.default, props);
};

var _default = Menu;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lbnUvTWVudS50c3giXSwibmFtZXMiOlsiTWVudSIsInByb3BzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7OztBQUtBLElBQU1BLElBQTRCLEdBQUcsU0FBL0JBLElBQStCLENBQUNDLEtBQUQ7QUFBQSxzQkFBVyw2QkFBQyxhQUFELEVBQWFBLEtBQWIsQ0FBWDtBQUFBLENBQXJDOztlQUVlRCxJIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IE1lbnUgYXMgTXVpTWVudSwgTWVudVByb3BzIGFzIE11aU1lbnVQcm9wcyB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlJztcblxuZXhwb3J0IHR5cGUgTWVudVByb3BzID0gTXVpTWVudVByb3BzO1xuXG5jb25zdCBNZW51OiBSZWFjdC5GQzxNdWlNZW51UHJvcHM+ID0gKHByb3BzKSA9PiA8TXVpTWVudSB7Li4ucHJvcHN9IC8+O1xuXG5leHBvcnQgZGVmYXVsdCBNZW51O1xuIl19